// Per-route canonical URL helper.
//
// The site is an SPA served from a single index.html, so the static
// <link rel="canonical"> in index.html would otherwise apply to every route
// (making /privacy look like a duplicate of /). Each page calls this so its
// canonical URL self-references.
const SITE_ORIGIN = 'https://awayfx.com';

export function setCanonical(path: string): void {
  if (typeof document === 'undefined') return;
  const href = `${SITE_ORIGIN}${path}`;
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}
